module.exports = __webpack_public_path__ + "img/features-illustration.74b4d44f.png";